import { api } from './client'
import type { Product } from '@/types'

export const storeApi = {
  getProducts: () => api.get<Product[]>('/store/products'),
  getProduct: (id: string) => api.get<Product>(`/store/products/${id}`),
}
